<template>
  <div class="container-md plr-0" :key="'user_' + $route.params.id">
    <div class="container-bg p-5 c-pro-wrap">
      <table class="table">
        <tbody>
          <tr>
            <td><h3 class="text-uppercase">Privacy</h3></td>
            <td class="d-flex justify-content-center">
              <button class="btn btn-dark position-relative">
                <input
                  @change="selectAllBox"
                  class="form-check-input all-check"
                  type="checkbox"
                  v-model="selectAll"
                />
                <span>Alles</span>
              </button>
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('display_name')">
            <td>Weergavenaam</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.display_name"
                disabled
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('profile_image')">
            <td>Profiel foto</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.profile_image"
                disabled
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('firstname')">
            <td>Voornaam</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.firstname"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('lastname')">
            <td>Achternaam</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.lastname"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('address')">
            <td>Adres</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.address"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('zipcode')">
            <td>Postcode</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.zipcode"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('city')">
            <td>Plaats</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.city"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('phone')">
            <td>Telefoonnummer</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.phone"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('mobile')">
            <td>Telefoonnummer (mobiel)</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.mobile"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('website')">
            <td>Website</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.website"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('gender')">
            <td>Geslacht</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.gender"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('date_of_birth')">
            <td>Geboortedatum</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.date_of_birth"
              />
            </td>
          </tr>
          <tr v-if="!hideUserAttributes.includes('about_me')">
            <td>Over mij</td>
            <td class="d-flex justify-content-center">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="item.about_me"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-dark" @click="submit">Opslaan</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "profilePrivacy",
  data() {
    return {
      item: {
        display_name: true,
        profile_image: true,
        firstname: false,
        lastname: false,
        address: false,
        zipcode: false,
        city: false,
        phone: false,
        mobile: false,
        website: false,
        gender: false,
        date_of_birth: false,
        about_me: false,
      },
      loading: false,
      selectAll: false,
      hideUserAttributes: process.env.VUE_APP_HIDE_USER_ATTRIBUTES.split(","),
    };
  },
  methods: {
    selectAllBox() {
      this.item = {
        display_name: !this.hideUserAttributes.includes("display_name"),
        profile_image: !this.hideUserAttributes.includes("profile_image"),
        firstname:
          !this.hideUserAttributes.includes("firstname") && this.selectAll,
        lastname:
          !this.hideUserAttributes.includes("lastname") && this.selectAll,
        address: !this.hideUserAttributes.includes("address") && this.selectAll,
        zipcode: !this.hideUserAttributes.includes("zipcode") && this.selectAll,
        city: !this.hideUserAttributes.includes("city") && this.selectAll,
        phone: !this.hideUserAttributes.includes("phone") && this.selectAll,
        mobile: !this.hideUserAttributes.includes("mobile") && this.selectAll,
        website: !this.hideUserAttributes.includes("website") && this.selectAll,
        gender: !this.hideUserAttributes.includes("gender") && this.selectAll,
        date_of_birth:
          !this.hideUserAttributes.includes("date_of_birth") && this.selectAll,
        about_me:
          !this.hideUserAttributes.includes("about_me") && this.selectAll,
      };
    },
    submit() {
      this.$store
        .dispatch("put", {
          endpoint: "api/v1/users/" + this.$route.params.id,
          details: { privacy_settings: this.item },
        })
        .then(() => {
          this.loading = false;
          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "Privacy instellingen opgeslagen",
          });
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
          console.log(error.request);
          this.loading = false;
        });
    },
    init(user) {
      let settings = JSON.parse(user.privacy_settings);

      this.item = {
        display_name: true,
        profile_image: true,
        firstname: !settings?.firstname ? false : true,
        lastname: !settings?.lastname ? false : true,
        address: !settings?.address ? false : true,
        zipcode: !settings?.zipcode ? false : true,
        city: !settings?.city ? false : true,
        phone: !settings?.phone ? false : true,
        mobile: !settings?.mobile ? false : true,
        website: !settings?.website ? false : true,
        gender: !settings?.gender ? false : true,
        date_of_birth: !settings?.date_of_birth ? false : true,
        about_me: !settings?.about_me ? false : true,
      };
    },
  },
  mounted() {
    this.init(this.$store.state.auth.user);
  },
};
</script>
<style>
.all-check {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  margin-top: -0.4rem !important;
  margin-left: -1.5rem !important;
}
</style>
